import React, { useCallback, useEffect, useMemo, useState } from "react";
// import { getHeight, getWidth } from 'utils/helpers/relativeSizes'
// import { DeviceEventEmitter, Image, StyleSheet, TouchableOpacity, View } from 'react-native'
import { EventEmitter } from "events";
import { COMMON_IMAGES, GAMEPLAY_HYBRID_IMAGES } from "../../../assets/images";
import styles from "./styles.module.css";
import clsx from "clsx";
// import TimerCircularAnimation from 'screens/gameplay/ludoNx/components/TimerCircularAnimation'
// import { useSelector } from 'react-redux'
// import {
//   getDiceValue,
//   getIsMySeatIndex,
//   getResetTimer,
//   getStartDice,
//   getTimeLeft,
//   getTotalTurnTime,
//   getTst,
//   getTurnSi
// } from 'screens/gameplay/store/selectors'
// import { DICE2P_NUMBER_IMAGE, SOUND_KEYS, TST_ROUND_STARTED } from 'screens/gameplay/constants'
import { NX_TIMER_TYPES, PLAYER_NUMBER } from "../../../pages/GamePlay/types";
import _isNil from "lodash/isNil";
import _isEmpty from "lodash/isEmpty";
import { DTGS, DTGS_EVENTS } from "../../../utils/helpers/constants";
import { parseString } from "../../../utils/helpers/common";
import { EMPTY_OBJECT } from "../../../utils/helpers/empty";
import ImageComponent from "../../ImageComponent";
import {
  DICE2P_NUMBER_IMAGE,
  SOUND_KEYS,
  TST_ROUND_STARTED,
} from "../constant";
import { getHeight, getWidth } from "../../../utils/relativeSizes";
import DiceAnimation from "../ludoboard/components/DiceAnimation/DiceAnimation";
// import TimerCircularAnimation from "../TimerCircularAnimation/TimerCircularAnimation";
import { useSelector } from "react-redux";
import { store } from "../../../store";
import { getEventProcessor } from "../../../pages/GamePlay/eventProcessor";
import {
  getDiceValue,
  getIsMySeatIndex,
  getResetTimer,
  getShowTurnTimer,
  getStartDice,
  getTimeLeft,
  getTotalTurnTime,
  getTst,
  getTurnSi,
} from "../../../store/selectors/ludoboardSelectors";
import TimerCircularAnimation from "../TimerCircularAnimation/TimerCircularAnimation";
import { playSound, vibrate } from "../../../classes/sound";
import { emit } from "../../../classes/socket/gameplay";
// import { playSound } from '../../../classes/sound';

const ANIMATED_DICE = "animatedDice";
const VIP_DEFAULT_IMAGE_KEY = 0;
const DEFAULT_LUDO_DICE_CLASSIC = "classic";

function Dice({ topInset }: { topInset?: number }) {
  const { dispatch, getState } = store;
  const eventEmitter = new EventEmitter();
  const timeLeft = useSelector(getTimeLeft) || 0;
  const totalTurnTime = useSelector(getTotalTurnTime);
  const turnSi = useSelector(getTurnSi);
  const startDice = useSelector(getStartDice);
  const dv = useSelector(getDiceValue);
  const tst = useSelector(getTst);
  const resetTimer = useSelector(getResetTimer);
  const isMySeatIndex = useSelector(
    getIsMySeatIndex.bind(null, PLAYER_NUMBER.ONE)
  );
  const isTurn = turnSi === 0;
  const showTurnTimer = useSelector(getShowTurnTimer);

  // const vipDiceData = useSelector(getVipDiceInfo)
  // const vipConfig = useSelector(getVipConfig)

  // const isVipUser = vipConfig?.isVip && vipConfig?.isVipFeatureEnabled && vipConfig?.allDiceImagesDownloadedSuccessfully
  // const vipDice = !_isEmpty(vipDiceData?.color) ? vipDiceData.color : vipConfig?.dice?.color

  // in loduonx no vip option
  const shouldShowVip = false;
  const handleDiceClick = useCallback(() => {
    if (tst === TST_ROUND_STARTED && showTurnTimer) {
      if (turnSi === 0 && _isNil(startDice)) {
        // eventEmitter.emit(DTGS, {
        //   en: DTGS_EVENTS.EMIT,
        //   data: parseString({ en: "RC", data: EMPTY_OBJECT }),
        // });
        emit(parseString({ en: "RC", data: EMPTY_OBJECT }));
        getEventProcessor()?.processAnimateDice("click");
      } else {
        playSound(SOUND_KEYS.NOTIFICATION);
      }
    }
  }, [tst, showTurnTimer, turnSi, startDice, eventEmitter]);

  useEffect(() => {
    if (isTurn && startDice) {
      playSound(SOUND_KEYS.ROLL_DICE);
    }
  }, [isTurn, startDice]);

  useEffect(() => {
    if (isTurn && isMySeatIndex) {
      playSound(SOUND_KEYS.USER_TURN);
      vibrate();
    }
  }, [isTurn, isMySeatIndex, resetTimer]);

  return (
    <div
      className={clsx(styles.diceContainer)}
      style={{top: getHeight(645)}}
      // style={{ top: topInset + getHeight(645) }}
    >
      <div
        className={clsx(styles.diceBG)}
        style={{ height: getWidth(80), width: getWidth(80) }}
        onClick={handleDiceClick}
      >
        {/* {turnSi === 0 && (
          <TimerCircularAnimation
            totalTurnTime={totalTurnTime}
            timeLeft={timeLeft}
            resetTimer={resetTimer}
            timerType={NX_TIMER_TYPES.TURN}
          />
        )} */}
        {turnSi === 0 && showTurnTimer && (
          <TimerCircularAnimation
            totalTurnTime={totalTurnTime} // Total time in seconds
            timeLeft={timeLeft} // Remaining time in seconds
            resetTimer={resetTimer} // A value that changes to reset the timer
            timerType={NX_TIMER_TYPES.TURN} // Timer type
            percentageToChangeColorFrom={0.75} // Change color after 50% progress
          />
        )}
        {startDice === null && (
          <span style={{ height: getWidth(48), width: getWidth(48) }}>
            <ImageComponent
              src={GAMEPLAY_HYBRID_IMAGES.kingDice}
              alt={""}
              className={clsx(styles.dice)}
              style={{
                height: getWidth(48),
                width: getWidth(48)
              }}
            />
          </span>
        )}
        {/* {turnSi === 0 && startDice === true && (
          <DiceAnimation shouldShowVip={true} source={{ uri: getVipDiceImages(vipDice, ANIMATED_DICE) }} />
        )} */}
        {turnSi === 0 && startDice && (
          <DiceAnimation shouldShowVip={shouldShowVip} />
        )}

        {turnSi === 0 && startDice === false && !_isNil(dv) && (
          <span style={{ height: getWidth(48), width: getWidth(48) }}>
            <ImageComponent
              src={DICE2P_NUMBER_IMAGE[(dv + 1) as PLAYER_NUMBER]}
              alt={""} // style={styles.dice}
              style={{
                height: getWidth(48),
                width: getWidth(48)
              }}
            />
          </span>
        )}
      </div>
    </div>
  );
}

export default Dice;
